import React from 'react'
import './github.css'
export default function Heading(props) {
    return (
        <div>
            <div className="section-heading" style={props.style}>
                <h3>{props.heading}</h3>
            </div>
        </div>
    )
}
